module.exports = __webpack_public_path__ + "img/full-screen.d2c8737f.svg";